import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Moment from 'react-moment';
import { reactLocalStorage } from 'reactjs-localstorage';
import Hor_header from "../header/hor_header";
import Ver_header from "../header/ver_header";
import Footer from "../footer/footer";

import { API_URL } from "../constant";
import Loader from "./loading";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import DataTable from 'react-data-table-component';

import "react-data-table-component-extensions/dist/index.css";

import { format } from 'date-fns';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function HealthReport() {

    const navigat = useNavigate();

    const [userData, setUserData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [districtData, setDistrictData] = useState([]);
    const [blockData, setBlockData] = useState([]);
    const [chcData, setChcData] = useState([]);
    const [staffData, setStaffData] = useState('all');
    const [typ, setTyp] = useState({ ftype: "all", id: "" });

    const [pages, setPage] = useState(1);

    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);

    const [totalData, setTotalData] = useState();
    const [totalDetailData, setTotalDetailData] = useState();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [disabled,setDisabled] = useState(false);
    const [disabledData,setDisabledData] = useState(false);

    const [severeRecoverPatient,setSevereRecoverPatient] =useState([]);
    const [moderateRecoverPatient,setModerateRecoverPatient] =useState([]);
    const [mildRecoverPatient,setMildRecoverPatient] =useState([]);
    const [nonanemicRecoverPatient,setNonanemicRecoverPatient] =useState([]);


    useEffect(() => {
        document.title = "Health Reports";
     
        getDistrictList();
        getSevereRecoveredPatientData();
        getModerateRecoveredPatientData();
        getMildRecoveredPatientData();
        getnonAneamicToOtherPatientData()
    
    }, [1]
    );




    const getFilterUserData = () => {
        setDisabled(true);
      //  setDisabledData(true);
    
        getSevereRecoveredPatientData();
        getModerateRecoveredPatientData();
        getMildRecoveredPatientData();
        getnonAneamicToOtherPatientData();
     
    }


    /********District based on state*********** */
    let getDistrictList = async (e) => {
        setDistrictData([]);
       
        let state_id = 1;
        const regDataDistrict = {
            method: 'Post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'state_id': state_id })
        }
        const getDistrict = await fetch(API_URL + 'admin/district', regDataDistrict);
        const getdataDistrict = await getDistrict.json();

        if (getdataDistrict.Rdata.length > 0) {
            setDistrictData(getdataDistrict.Rdata);

        }

    }
    /********Block based on district*********** */
    let getBlock = async (e) => {
        setBlockData([]);
        let district_id = e.target.value;
        
        const reDataDistrict = {
            method: 'Post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'district_id': district_id })
        }
        const getBlock = await fetch(API_URL + "admin/block", reDataDistrict);
        const getBlockData = await getBlock.json();
        
        if (getBlockData.Rdata.length > 0) {
            setBlockData(getBlockData.Rdata);

        }

    }



    /****************Get Chc on block**************************** */

    let getChc = async (e) => {
        setChcData([]);

        let block_id = e.target.value;
       
        const reDataBlock = {
            method: 'Post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'block_id': block_id })
        }
        /************chc************** */
        const getChc = await fetch(API_URL + "admin/getChc", reDataBlock);
        const getChcData = await getChc.json();
       
        if (getChcData.Rdata.length > 0) {
            setChcData(getChcData.Rdata);

        }


    }

    /*****************severe to improve************************ */
    
     const col =  [
        { header: 'Name', key: 'name' },
        { header: 'Beneficiary Type', key: 'beneficiary_type' },
        { header: 'Patient id', key: 'patient_id' },
        { header: 'Family Head Name', key: 'guardian_name' },
        { header: 'Mobile No', key: 'mobile_no' },
        { header: 'Gender', key: 'gender' },
        { header: 'Caste', key: 'caste' },
        { header: 'Age id', key: 'age' },
        { header: 'Pregnancy Duration', key: 'preg_duration' },
        { header: 'Address', key: 'address' },
        { header: 'Staff Type', key: 'staff_type' },
        { header: 'Added By Anm/Medical Team Id', key: 'anm_med_nur_name' },
        { header: 'Rch id', key: 'rch_uid' },
        { header: 'District', key: 'district_name' },
        { header: 'Block', key: 'block_name' },
        { header: 'CHC/PHC', key: 'chc_name' },
        { header: 'Village', key: 'village_name' },
        { header: 'School', key: 'school_name' },
        { header: 'Haemoglobin value', key: 'haemoglobin_value' },
        { header: 'Haemoglobin based status', key: 'haemoglobin_based_status' },
        { header: 'Height', key: 'height' },
        { header: 'Weight', key: 'weight' },
        { header: 'BMI value', key: 'bmi_value' },
        { header: 'BMI Status', key: 'bmi_category' },
        { header: 'Pregnancy Duration(At time of test)', key: 'pregnancy_duration' },
        { header: 'Latitude', key: 'ts_lat' },
        { header: 'Longitude', key: 'ts_log' },
        { header: 'Venue', key: 'venue' },
        { header: 'Current Address', key: 'curr_address' },
        { header: 'Referral status', key: 'referral_status' },
        { header: 'Referred At', key: 'referred_center_name' },
        { header: 'Test done on', key: 'investigated_on' },
        { header: 'Test Done By (Not ref.)', key: 'anm_med_nur_name' },
        { header: 'Test Done By (ref.)', key: 'test_hos_name' },
        { header: 'Referred By Hospital', key: 'referred_by_hos_name' },
        { header: 'Medician', key: 'medician' },
        { header: 'Dose', key: 'dose' },
        { header: 'Treatment given by', key: 'treat_giv_by_name' },
        { header: 'Follow up date', key: 'follow_up_date' },
        { header: 'Treatment Given on', key: 'treatment_on' },
        { header: 'Added On', key: 'added_on' },


    ]
   



    const ensureAllStatuses = (data) => {
        const requiredStatuses = ['mild', 'moderate', 'nonanemic','severe'];

        // Convert to a Map for faster lookup
        const dataMap = new Map(data.map(item => [item.haemoglobin_based_status, item.count]));

        // Fill missing with 0
        return requiredStatuses.map(status => ({
            haemoglobin_based_status: status,
            count: dataMap.get(status) || 0
        }));
        };

    let getSevereRecoveredPatientData = async () => {
          setIsLoading(true);

        let datas = {typeOfHb:'severe', ftype: typ.ftype, data: typ.id, staff: staffData, fromDate: startDate ? format(startDate, 'dd-MM-yyyy') : null, toDate: endDate ? format(endDate,'dd-MM-yyyy'):null };
       
        var url = "";
        if (reactLocalStorage.get('userLoginType') == 'Admin') {
            url = 'admin/getRecoveredSeverePatient';
        } else {
            url = 'chc/getRecoveredSeverePatient';
            datas = { ...datas, ...{ "userType": reactLocalStorage.get("userType"), "userLoginType": reactLocalStorage.get("userLoginType") } }
        }
        const res = await axios.post(API_URL + url, datas)
            .then(ress => {
               
               const sdata= ensureAllStatuses(ress.data.Rdata);
              //  console.log("sever",sdata)
                setSevereRecoverPatient(sdata);
                 setIsLoading(false);
            });
            setDisabled(false);
           
    }

      let getModerateRecoveredPatientData = async () => {
        

        let datas = {typeOfHb:'moderate', ftype: typ.ftype, data: typ.id, staff: staffData, fromDate: startDate ? format(startDate, 'dd-MM-yyyy') : null, toDate: endDate ? format(endDate,'dd-MM-yyyy'):null };
       
        var url = "";
        if (reactLocalStorage.get('userLoginType') == 'Admin') {
            url = 'admin/getRecoveredSeverePatient';
        } else {
            url = 'chc/getRecoveredSeverePatient';
            datas = { ...datas, ...{ "userType": reactLocalStorage.get("userType"), "userLoginType": reactLocalStorage.get("userLoginType") } }
        }
        const res = await axios.post(API_URL + url, datas)
            .then(ress => {
               
               const sdata= ensureAllStatuses(ress.data.Rdata);
               // console.log("sever",sdata)
                setModerateRecoverPatient(sdata);

            });
            setDisabled(false);
           
    }

     let getMildRecoveredPatientData = async () => {
          

        let datas = {typeOfHb:'mild', ftype: typ.ftype, data: typ.id, staff: staffData, fromDate: startDate ? format(startDate, 'dd-MM-yyyy') : null, toDate: endDate ? format(endDate,'dd-MM-yyyy'):null };
       
        var url = "";
        if (reactLocalStorage.get('userLoginType') == 'Admin') {
            url = 'admin/getRecoveredSeverePatient';
        } else {
            url = 'chc/getRecoveredSeverePatient';
            datas = { ...datas, ...{ "userType": reactLocalStorage.get("userType"), "userLoginType": reactLocalStorage.get("userLoginType") } }
        }
        const res = await axios.post(API_URL + url, datas)
            .then(ress => {
               
               const sdata= ensureAllStatuses(ress.data.Rdata);
              //  console.log("mild",sdata)
                setMildRecoverPatient(sdata);

            });
            setDisabled(false);
           
    }

    let getnonAneamicToOtherPatientData = async () => {
        

        let datas = {typeOfHb:'nonanemic', ftype: typ.ftype, data: typ.id, staff: staffData, fromDate: startDate ? format(startDate, 'dd-MM-yyyy') : null, toDate: endDate ? format(endDate,'dd-MM-yyyy'):null };
       
        var url = "";
        if (reactLocalStorage.get('userLoginType') == 'Admin') {
            url = 'admin/getRecoveredSeverePatient';
        } else {
            url = 'chc/getRecoveredSeverePatient';
            datas = { ...datas, ...{ "userType": reactLocalStorage.get("userType"), "userLoginType": reactLocalStorage.get("userLoginType") } }
        }
        const res = await axios.post(API_URL + url, datas)
            .then(ress => {
               
               const sdata= ensureAllStatuses(ress.data.Rdata);
              //  console.log("mild",sdata)
                setNonanemicRecoverPatient(sdata);

            });
            setDisabled(false);
           
    }

    
     let getExportPatientDetailsData = async (hbt) => {
            setDisabled(true);

         let datas = {typeOfHb:hbt, ftype: typ.ftype, data: typ.id, staff: staffData, fromDate: startDate ? format(startDate, 'dd-MM-yyyy') : null, toDate: endDate ? format(endDate,'dd-MM-yyyy'):null };
       
       
        var url = "";
        if (reactLocalStorage.get('userLoginType') == 'Admin') {
            url = 'admin/getBeneficiary_health_detailed_export_csv';
        } else {
            url = 'chc/getBeneficiary_health_detailed_export_csv';
            datas = { ...datas, ...{ "userType": reactLocalStorage.get("userType"), "userLoginType": reactLocalStorage.get("userLoginType") } }
        }
        const res = await axios.post(API_URL + url, datas)
            .then(ress => {
                
            //    setTotalData(ress.data.Rdata);
            //     dwn(hbt);


              const workbook = new ExcelJS.Workbook();
              const worksheet = workbook.addWorksheet('AllBeneficaryHealthReportData_'+hbt);
              worksheet.columns=col;  

              let lastId = null;
                let colorToggle = false;
                const colorMap = {
                    true: 'FFEB9C',  // light yellow
                    false: 'C6EFCE'  // light green
                };
                ress?.data?.Rdata.forEach(row => {
                    const isSame = row.patient_id === lastId;
                    if (!isSame) colorToggle = !colorToggle;
                    lastId = row.patient_id;

                    const addedRow = worksheet.addRow(row);
                    addedRow.eachCell((cell) => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: colorMap[colorToggle] }
                    };
                    });
                });
                    worksheet.getRow(1).eachCell((cell) => {
                cell.font = { bold: true };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'CCCCFF' }  // Light purple background
                };
                });


                 // Export
                
                workbook.xlsx.writeBuffer().then((buffer) => {
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    saveAs(blob, 'AllUserHealthReport_'+hbt+'.xlsx');
                });
            
            });
               setDisabled(false);
    }




   

     



    const handleStartDateChange = (date) => {
       
        setStartDate(date);
    };

    


    const handleEndDateChange = (date) => {
        setEndDate(date);
    };





    return (

        <div className="container-scroller">

            <Hor_header />

            <div className="container-fluid page-body-wrapper">

                <Ver_header />

                <div className="main-panel">
                   
                            <div className="content-wrapper">

                                <div className="row">

                                    <div className="col-md-2">
                                        <div className="form-group row">
                                            <label className="col-sm-12">Select District </label>
                                            <div className="col-sm-12">
                                                <select className="form-control" name="district" onChange={(e) => { getBlock(e); setTyp({ ftype: 'district_id', id: e.target.value }); }} required>
                                                    <option value='0' >Select</option>
                                                    {districtData.map(district => (
                                                        ((reactLocalStorage.get("userLoginType") == "Chc") || (reactLocalStorage.get("userLoginType") == "Block") || (reactLocalStorage.get("userLoginType") == "District")) ? ((reactLocalStorage.get("district") == district.id) ? <option value={district.id}>{district.name} </option> : "") : <option value={district.id}>{district.name} </option>

                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="form-group row">
                                            <label className="col-sm-12">Select Block </label>
                                            <div className="col-sm-12">
                                                <select className="form-control" name="block" onChange={(e) => { getChc(e); setTyp({ ftype: 'block_id', id: e.target.value }); }} required>
                                                    <option value='0'>Select</option>
                                                    {blockData.map(blocks => (
                                                        ((reactLocalStorage.get("userLoginType") == 'Chc') || (reactLocalStorage.get("userLoginType") == 'Block')) ? (reactLocalStorage.get("block") == blocks.id) ? <option value={blocks.id}>{blocks.name}</option> : "" : <option value={blocks.id}>{blocks.name}</option>

                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="form-group row">
                                            <label className="col-sm-12">Select CHC/PHC </label>
                                            <div className="col-sm-12">
                                                <select className="form-control" name="chc" onChange={(e) => { setTyp({ ftype: 'chc_phc_id', id: e.target.value }); }} required>
                                                    <option value='0'>Select</option>
                                                    {chcData.map(chc => (
                                                        (reactLocalStorage.get("userLoginType") == 'Chc') ? ((reactLocalStorage.get("userType") == chc.id) ? <option value={chc.id}>{chc.name}</option> : "") : <option value={chc.id}>{chc.name}</option>

                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group row">
                                            <label className="col-sm-12">Select Staff Type </label>
                                            <div className="col-sm-12">
                                                <select className="form-control" name="userType" onChange={(e) => { setStaffData(e.target.value) }} required>
                                                    <option value="all">Select</option>
                                                    <option value="anm">ANM</option>
                                                    <option value="medicalteam">RBSK Medical Team</option>
                                                    <option value="nurse">Staff Nurse</option>
                                                    <option value="LT">LT</option>
                                                    <option value="CHO">CHO</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 date-selection">
                                        <div class="row">
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-sm-12">Select Date </label>
                                                    <div className="col-sm-12">
                                                        <DatePicker
                                                            selected={startDate}
                                                            onChange={handleStartDateChange}
                                                            name="dob"
                                                            dateFormat="dd-MM-yyyy"
                                                            dropdownMode="select"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            adjustDateOnChange
                                                            minDate={new Date('01-01-1950')}
                                                            maxDate={new Date()}
                                                            placeholderText="From"
                                                            className="form-control"
                                                            id="dobpicker"
                                                            tabIndex="5"
                                                            onKeyDown={e => e.preventDefault()}
                                                            autoComplete="off"
                                                            

                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-sm-12">End Date </label>
                                                    <div className="col-sm-12">
                                                        <DatePicker
                                                            selected={endDate}
                                                            onChange={handleEndDateChange}
                                                            name="dob"
                                                            dateFormat="dd-MM-yyyy"
                                                            dropdownMode="select"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            adjustDateOnChange
                                                            minDate={new Date('01-01-1950')}
                                                            maxDate={new Date()}
                                                            placeholderText="To"
                                                            className="form-control"
                                                            id="dobpicker"
                                                            tabIndex="5"
                                                            onKeyDown={e => e.preventDefault()}
                                                            autoComplete="off"

                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className="row">
                                    <div className="col-md-12 text-right">
                                        <div className="form-group row">

                                            <div className="col-sm-12">
                                                <button className="btn btn-primary" onClick={getFilterUserData} >Go</button>&nbsp;
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="row">
                                    <div className="col-lg-12 grid-margin stretch-card">
                                        <div className="card">
                                            <div className="card-body">
                                              <h5> Benificary Health Report </h5>   
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                  {isLoading ? (<Loader />) : (
                               <>
                                 <div className="row">
                                    <div className="col-lg-12 grid-margin stretch-card">
                                        <div className="card">
                                            <div className="card-body">
                                               Benificary Health Report Of <b>Severe Patient</b>
                                                &nbsp; &nbsp; <button className="btn btn-success" onClick={()=>{getExportPatientDetailsData('severe')}} disabled={disabled} >Export</button>

                                                <div className="table-responsive pt-3">
                                                      <div>
                                                        <div>
                                                            <b>Severe To</b> : (Previously Severe Total Patient : {parseInt(severeRecoverPatient[0]?.count) + parseInt(severeRecoverPatient[1]?.count) + parseInt(severeRecoverPatient[2]?.count) + parseInt(severeRecoverPatient[3]?.count)})
                                                        </div>
                                                        <div>
                                                            Moderate: {severeRecoverPatient[1]?.count}
                                                        </div>
                                                         <div>
                                                            Mild: {severeRecoverPatient[0]?.count}
                                                        </div>
                                                         <div>
                                                            Nonanemic: {severeRecoverPatient[2]?.count}
                                                        </div>
                                                         <div>
                                                            Still Severe: {severeRecoverPatient[3]?.count}
                                                        </div>
                                                      </div>
                                                      

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-12 grid-margin stretch-card">
                                        <div className="card">
                                            <div className="card-body">
                                                  Benificary Health Report Of <b>Moderate Patient</b>
                                                   &nbsp; &nbsp; <button className="btn btn-success" onClick={()=>{getExportPatientDetailsData('moderate')}} disabled={disabled} >Export</button>

                                                <div className="table-responsive pt-3">
                                                      <div>
                                                        <div>
                                                            <b>Moderate To</b> : (Previously Moderate Total Patient : {parseInt(moderateRecoverPatient[0]?.count) + parseInt(moderateRecoverPatient[1]?.count) + parseInt(moderateRecoverPatient[2]?.count) + parseInt(moderateRecoverPatient[3]?.count)})
                                                        </div>
                                                        <div>
                                                           Still   Moderate: {moderateRecoverPatient[1]?.count}
                                                        </div>
                                                         <div>
                                                            Mild: {moderateRecoverPatient[0]?.count}
                                                        </div>
                                                         <div>
                                                            Nonanemic: {moderateRecoverPatient[2]?.count}
                                                        </div>
                                                         <div>
                                                             Severe: {moderateRecoverPatient[3]?.count}
                                                        </div>
                                                      </div>
                                                      

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                  <div className="row">
                                    <div className="col-lg-12 grid-margin stretch-card">
                                        <div className="card">
                                            <div className="card-body">
                                                Benificary Health Report Of <b>Mild Patient</b>
                                                     &nbsp; &nbsp; <button className="btn btn-success" onClick={()=>{getExportPatientDetailsData('mild')}} disabled={disabled} >Export</button>
                                                <div className="table-responsive pt-3">
                                                      <div>
                                                        <div>
                                                            <b>Mild To</b> : (Previously Mild Total Patient : {parseInt(mildRecoverPatient[0]?.count) + parseInt(mildRecoverPatient[1]?.count) + parseInt(mildRecoverPatient[2]?.count) + parseInt(mildRecoverPatient[3]?.count)})
                                                        </div>
                                                        <div>
                                                            Moderate: {mildRecoverPatient[1]?.count}
                                                        </div>
                                                         <div>
                                                           Still Mild: {mildRecoverPatient[0]?.count}
                                                        </div>
                                                         <div>
                                                            Nonanemic: {mildRecoverPatient[2]?.count}
                                                        </div>
                                                         <div>
                                                             Severe: {mildRecoverPatient[3]?.count}
                                                        </div>

                                                      </div>
                                                     

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                 <div className="row">
                                    <div className="col-lg-12 grid-margin stretch-card">
                                        <div className="card">
                                            <div className="card-body">
                                                Benificary Health Report Of <b>Nonanemic Patient</b>  
                                                 &nbsp; &nbsp; <button className="btn btn-success" onClick={()=>{getExportPatientDetailsData('nonanemic')}} disabled={disabled} >Export</button>

                                                <div className="table-responsive pt-3">
                                                      <div>
                                                        <div>
                                                            <b>Nonanemic To</b> : (Previously Nonanemic Total Patient : {parseInt(nonanemicRecoverPatient[0]?.count) + parseInt(nonanemicRecoverPatient[1]?.count) + parseInt(nonanemicRecoverPatient[2]?.count) + parseInt(nonanemicRecoverPatient[3]?.count)})
                                                        </div>
                                                        <div>
                                                            Moderate: {nonanemicRecoverPatient[1]?.count}
                                                        </div>
                                                         <div>
                                                            Mild: {nonanemicRecoverPatient[0]?.count}
                                                        </div>
                                                         <div>
                                                          Still  Nonanemic: {nonanemicRecoverPatient[2]?.count}
                                                        </div>
                                                         <div>
                                                             Severe: {nonanemicRecoverPatient[3]?.count}
                                                        </div>
                                                      </div>
                                                      

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                               </> )}

                               
                            </div>

                            <Footer />
                    
                </div>

            </div>

        </div>);
}

export default HealthReport;